export default __webpack_public_path__ + "static/media/@3x_case_3(780_830).cce71128.png";